import { useState } from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import axios from "axios";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { MDBDataTable } from 'mdbreact';
import { CSVLink } from "react-csv";
import { currency, dateFormat, timeFormat, emailLogo, getApiUrl } from "../../../../dynamicController";
import { Tooltip, OverlayTrigger, Form } from 'react-bootstrap';
import Loading from "../Loading";
import { Modal } from "antd";
import rewardlogo from '../../../../assets/images/rewardlogo.png';
import refundlogo from '../../../../assets/images/refundlogo.png';

const mySwal = withReactContent(Swal);

const API_URL = getApiUrl()

const UserDetailsCard = ({ role, token, country, pointSetting, tokenSetting, stampSetting }) => {

    const { t } = useTranslation();

    const history = useHistory();

    const [loading, setLoading] = useState(false)
    const [data, setData] = useState([])
    const [phone, setPhone] = useState("")
    const [userCountry, setUserCountry] = useState(country)
    const [giveawayModal, setGiveawayModal] = useState(false)
    const [voucherModal, setVoucherModal] = useState(false)
    const [tokenModal, setTokenModal] = useState(false)
    const [stampModal, setStampModal] = useState(false)
    const [pointModal, setPointModal] = useState(false)
    const [userId, setUserId] = useState("")
    const [remark, setRemark] = useState("Reward")
    const [tokenAmount, setTokenAmount] = useState(0)
    const [pointAmount, setPointAmount] = useState(0)
    const [washerStamp, setWasherStamp] = useState(0)
    const [dryerStamp, setDryerStamp] = useState(0)
    const [title, setTitle] = useState("")
    const [description, setDescription] = useState("")
    const [duration, setDuration] = useState("")
    const [type, setType] = useState("Flat")
    const [amount, setAmount] = useState("")
    const [washerUse, setWasherUse] = useState(false)
    const [dryerUse, setDryerUse] = useState(false)
    const [packageUse, setPackageUse] = useState(false)
    const [vendingUse, setVendingUse] = useState(false)
    const [detergentUse, setDetergentUse] = useState(false)
    const [carwashUse, setCarwashUse] = useState(false)
    const [adminMessage, setAdminMessage] = useState("You have received your compensation. You may login your account to check it.")
    const [adminEmail, setAdminEmail] = useState("")
    const [adminCompanyName, setAdminCompanyName] = useState("")
    const [adminCompanyPhoneNo, setAdminCompanyPhoneNo] = useState("")
    const [showEmailPreview, setShowEmailPreview] = useState(false)
    const [selectedUserName, setSelectedUserName] = useState("")
    const [emailVerified, setEmailVerified] = useState(false)
    const [blocked, setBlocked] = useState(false)
    const [deactivateModal, setDeactivateModal] = useState(false)

    const memberDetailsReport = (memberId, userId, country) => {
        history.push(`/${role === "operator" ? "admin" : role === "distributor" ? "distributor" : "client"}/user/details/memberDetails`, { memberId, userId, country });
    }

    const handleSubmit = (e) => {
        e.preventDefault();

        if (phone) {
            setLoading(true)
            axios
                .post("/api/admin/setting/getUsers", { phone: phone.replace(/ /g, '') }, { headers: { "Content-Type": "application/json", "auth-token": token } })
                .then(res => {
                    setLoading(false)
                    setData(res.data.data)
                    if (!country) {
                        if (res.data.data.length > 0) {
                            setUserCountry(res.data.data[0].country)
                        }
                    }
                })
                .catch(err => {
                    setLoading(false)
                    mySwal.fire(t("Error"), t(err.response.data.error), "error");
                });
        } else {
            mySwal.fire(t("Info"), t("Please fill in all the required fields"), "info");
        }
    }

    const openDeactivateModal = (userId, blocked) => {
        setBlocked(blocked)
        setUserId(userId)
        setDeactivateModal(true)
    }

    const deactivateUser = () => {
        setLoading(true)
        const sendThis = {
            id: userId,
            blocked: !blocked,
        }

        axios
            .post("/api/admin/setting/deactivateUser", sendThis, { headers: { "Content-Type": "application/json", "auth-token": token } })
            .then((res) => {

                axios
                    .post("/api/admin/setting/getUsers", { phone: phone.replace(/ /g, '') }, { headers: { "Content-Type": "application/json", "auth-token": token } })
                    .then(res => {
                        setLoading(false)
                        setData(res.data.data)
                        setDeactivateModal(false)
                    })
                    .catch(err => {
                        setLoading(false)
                        mySwal.fire(t("Error"), t(err.response.data.error), "error");
                    });
            })
            .catch((err) => {
                setLoading(false)
                mySwal.fire(t("Error"), t(err.response.data.error), "error");
            });
    }

    const openGiveawayModal = (userId, country, userName, emailVerified) => {
        setUserId(userId)
        setUserCountry(country)
        setRemark("Reward")
        setTokenAmount(0)
        setPointAmount(0)
        setWasherStamp(0)
        setDryerStamp(0)
        setTitle("")
        setDescription("")
        setDuration("")
        setType("Flat")
        setAmount("")
        setWasherUse(false)
        setDryerUse(false)
        setPackageUse(false)
        setVendingUse(false)
        setDetergentUse(false)
        setCarwashUse(false)
        setGiveawayModal(true)
        setSelectedUserName(userName)
        setEmailVerified(emailVerified)
    };

    const giveVoucher = (e) => {
        e.preventDefault();

        if (!title || !description || !amount || parseFloat(amount) <= 0) {
            mySwal.fire(t("Missing Field"), t("Please fill in all the required field. (Title, description, and amount must be more than 0)"), "info");
        } else if (!washerUse && !dryerUse && !packageUse && !vendingUse && !detergentUse && !carwashUse) {
            mySwal.fire(t("Checkbox required"), t("Please select can be used for which type of transaction"), "info");
        } else if (!emailVerified && adminMessage.length > 130) {
            mySwal.fire(t("Error"), t("SMS will send to user, please enter the message less than 130 characters"), "error");
        } else {
            setLoading(true)
            const sendThis = {
                id: userId,
                rewardType: "Voucher",
                title,
                description,
                duration,
                type,
                amount,
                washerUse,
                dryerUse,
                packageUse,
                vendingUse,
                detergentUse,
                carwashUse,
                remark,
                adminMessage,
                adminEmail,
                adminCompanyName,
                adminCompanyPhoneNo,
            };

            axios
                .post("/api/admin/setting/giveaway", sendThis, { headers: { "Content-Type": "application/json", "auth-token": token } })
                .then((res) => {

                    axios
                        .post("/api/admin/setting/getUsers", { phone: phone.replace(/ /g, '') }, { headers: { "Content-Type": "application/json", "auth-token": token } })
                        .then(res => {
                            setLoading(false)
                            setData(res.data.data)
                            setVoucherModal(false)
                        })
                        .catch(err => {
                            setLoading(false)
                            mySwal.fire(t("Error"), t(err.response.data.error), "error");
                        });
                })
                .catch((err) => {
                    setLoading(false)
                    mySwal.fire(t("Error"), t(err.response.data.error), "error");
                });
        }
    }

    const giveStamp = (e) => {
        e.preventDefault();

        if (!parseInt(washerStamp) && !parseInt(dryerStamp)) {
            mySwal.fire(t("Error"), t("Please fill in at least one of the required fields"), "error");
        } else if ((parseInt(washerStamp) > 0 || parseInt(dryerStamp) > 0) && !emailVerified && adminMessage.length > 130) {
            mySwal.fire(t("Error"), t("SMS will send to user, please enter the message less than 130 characters"), "error");
        } else {
            setLoading(true)
            const sendThis = {
                id: userId,
                washerStamp,
                dryerStamp,
                rewardType: "Stamp",
                remark,
                adminMessage,
                adminEmail,
                adminCompanyName,
                adminCompanyPhoneNo,
            };

            axios
                .post("/api/admin/setting/giveaway", sendThis, { headers: { "Content-Type": "application/json", "auth-token": token } })
                .then((res) => {

                    axios
                        .post("/api/admin/setting/getUsers", { phone: phone.replace(/ /g, '') }, { headers: { "Content-Type": "application/json", "auth-token": token } })
                        .then(res => {
                            setLoading(false)
                            setData(res.data.data)
                            setStampModal(false)
                        })
                        .catch(err => {
                            setLoading(false)
                            mySwal.fire(t("Error"), t(err.response.data.error), "error");
                        });
                })
                .catch((err) => {
                    setLoading(false)
                    mySwal.fire(t("Error"), t(err.response.data.error), "error");
                });
        }
    };

    const givePoint = (e) => {
        e.preventDefault();

        if (!parseInt(pointAmount)) {
            mySwal.fire(t("Error"), t("Number of Point cannot be 0"), "error");
        } else if (parseInt(pointAmount) > 0 && !emailVerified && adminMessage.length > 130) {
            mySwal.fire(t("Error"), t("SMS will send to user, please enter the message less than 130 characters"), "error");
        } else {
            setLoading(true)
            const sendThis = {
                id: userId,
                point: pointAmount,
                rewardType: "Point",
                remark,
                adminMessage,
                adminEmail,
                adminCompanyName,
                adminCompanyPhoneNo,
            };

            axios
                .post("/api/admin/setting/giveaway", sendThis, { headers: { "Content-Type": "application/json", "auth-token": token } })
                .then((res) => {

                    axios
                        .post("/api/admin/setting/getUsers", { phone: phone.replace(/ /g, '') }, { headers: { "Content-Type": "application/json", "auth-token": token } })
                        .then(res => {
                            setLoading(false)
                            setData(res.data.data)
                            setPointModal(false)
                        })
                        .catch(err => {
                            setLoading(false)
                            mySwal.fire(t("Error"), t(err.response.data.error), "error");
                        });
                })
                .catch((err) => {
                    setLoading(false)
                    mySwal.fire(t("Error"), t(err.response.data.error), "error");
                });
        }
    };

    const giveToken = (e) => {
        e.preventDefault();

        if (!parseFloat(tokenAmount)) {
            mySwal.fire(t("Error"), t("Token value cannot be 0"), "error");
        } else if (parseFloat(tokenAmount) > 0 && !emailVerified && adminMessage.length > 130) {
            mySwal.fire(t("Error"), t("SMS will send to user, please enter the message less than 130 characters"), "error");
        } else {
            setLoading(true)
            const sendThis = {
                id: userId,
                token: tokenAmount,
                rewardType: "Token",
                remark,
                adminMessage,
                adminEmail,
                adminCompanyName,
                adminCompanyPhoneNo,
            };

            axios
                .post("/api/admin/setting/giveaway", sendThis, { headers: { "Content-Type": "application/json", "auth-token": token } })
                .then((res) => {

                    axios
                        .post("/api/admin/setting/getUsers", { phone: phone.replace(/ /g, '') }, { headers: { "Content-Type": "application/json", "auth-token": token } })
                        .then(res => {
                            setLoading(false)
                            setData(res.data.data)
                            setTokenModal(false)
                        })
                        .catch(err => {
                            setLoading(false)
                            mySwal.fire(t("Error"), t(err.response.data.error), "error");
                        });
                })
                .catch((err) => {
                    setLoading(false)
                    mySwal.fire(t("Error"), t(err.response.data.error), "error");
                });
        }
    };

    const generateEmailPreview = () => {
        let subject = '';
        let mainMessage = '';

        if (remark === "Refund") {
            subject = 'We Apologize for the Inconvenience';
            mainMessage = `
                <div style="text-align: center; padding: 0; background-color: #F9FAFF; font-family: 'Helvetica Neue', Arial, sans-serif; color: #4A4A4A;">
                    <div style="background-color: #34429A; padding: 20px; margin: 0;">
                        <img src="${emailLogo()}" alt="Company Logo" style="width: 150px; margin: 0;">
                    </div>
                    <div style="background-color: #FFFFFF; padding: 0; border-radius: 8px;">
                        <img src="${refundlogo}" alt="Money Logo" style="width: 100%; height: auto; margin: 0; display: block; margin-bottom: 20px;">
                        <p style="font-size: 16px; margin-bottom: 20px; text-align: left">Dear ${selectedUserName},</p>
                        <p style="font-size: 16px; margin-bottom: 20px; text-align: left">${adminMessage}</p>
                        <p style="font-size: 16px; margin-bottom: 20px; text-align: left">We sincerely apologize for any inconvenience or frustration this may have caused.</p>
                        <p style="font-size: 16px; margin-bottom: 20px; text-align: left">If you have any questions or require further assistance, please do not hesitate to contact our customer support team at ${adminCompanyPhoneNo} or ${adminEmail}.</p>
                        <p style="font-size: 16px; margin-bottom: 20px; text-align: left">Sincerely,</p>
                        <p style="font-size: 16px; margin-bottom: 20px; text-align: left"><strong>${adminCompanyName}</strong></p>
                        <p style="font-size: 16px; margin-bottom: 5px; text-align: left"><a href="mailto:${adminEmail}" style="color: #34429A;">${adminEmail}</a></p>
                        <p style="font-size: 16px; text-align: left"><a href="tel:${adminCompanyPhoneNo}" style="color: #34429A;">${adminCompanyPhoneNo}</a></p>
                    </div>
                </div>
                <div style="text-align: center;">
                    <a href="${API_URL}" style="display: inline-block; background-color: #004aad; color: #ffffff; padding: 10px 20px; border-radius: 50px; text-align: center; text-decoration: none; font-size: 16px; font-family: Arial, sans-serif; font-weight: bold; border: none; cursor: pointer;">Login Here</a>
                </div>
            `;
        } else if (remark === "Reward") {
            subject = 'Congratulations!';
            mainMessage = `
                <div style="text-align: center; padding: 0; background-color: #F9FAFF; font-family: 'Helvetica Neue', Arial, sans-serif; color: #4A4A4A;">
                    <div style="background-color: #34429A; padding: 20px; margin: 0;">
                        <img src="${emailLogo()}" alt="Company Logo" style="width: 150px; margin: 0;">
                    </div>
                    <div style="background-color: #FFFFFF; padding: 0; border-radius: 8px;">
                        <img src="${rewardlogo}" alt="Reward Image" style="width: 100%; height: auto; margin: 0; display: block; margin-bottom: 20px;">
                        <p style="font-size: 16px; margin-bottom: 20px; text-align: left">Dear ${selectedUserName},</p>
                        <p style="font-size: 16px; margin-bottom: 20px; text-align: left">${adminMessage}</p>
                        <p style="font-size: 16px; margin-bottom: 20px; text-align: left">If you have any questions or require further assistance, please do not hesitate to contact our customer support team at ${adminCompanyPhoneNo} or ${adminEmail}.</p>
                        <p style="font-size: 16px; margin-bottom: 20px; text-align: left">Sincerely,</p>
                        <p style="font-size: 16px; margin-bottom: 20px; text-align: left"><strong>${adminCompanyName}</strong></p>
                        <p style="font-size: 16px; margin-bottom: 5px; text-align: left"><a href="mailto:${adminEmail}" style="color: #34429A;">${adminEmail}</a></p>
                        <p style="font-size: 16px; text-align: left"><a href="tel:${adminCompanyPhoneNo}" style="color: #34429A;">${adminCompanyPhoneNo}</a></p>
                    </div>
                </div>
                <div style="text-align: center;">
                    <a href="${API_URL}" style="display: inline-block; background-color: #004aad; color: #ffffff; padding: 10px 20px; border-radius: 50px; text-align: center; text-decoration: none; font-size: 16px; font-family: Arial, sans-serif; font-weight: bold; border: none; cursor: pointer;">Login Here</a>
                </div>
            `;
        }

        return `
            <!DOCTYPE html>
            <html>
            <head>
                <meta charset="UTF-8">
                <meta name="viewport" content="width=device-width, initial-scale=1.0">
                <title>${subject}</title>
            </head>
            <body style="margin: 0; padding: 0;">
                ${mainMessage}
            </body>
            </html>
        `;
    }

    let tableData = {
        columns: [
            {
                label: t("Action"),
                field: "action",
            },
            {
                label: t("Member Details Report"),
                field: "report",
                sort: "asc"
            },
            {
                label: t("Salutation"),
                field: "salutation",
                sort: "asc"
            },
            {
                label: t("Name"),
                field: "name",
                sort: "asc"
            },
            {
                label: t("Phone Number"),
                field: "number",
                sort: "asc"
            },
            {
                label: t("Birthday"),
                field: "birthday",
                sort: "asc"
            },
            {
                label: t("Age"),
                field: "age",
                sort: "asc"
            },
            {
                label: t("Email Address"),
                field: "email",
                sort: "asc"
            },
            {
                label: t("Member ID"),
                field: "memberId",
                sort: "asc"
            },
            {
                label: t("ID Type"),
                field: "einvoice_id_type",
                sort: "asc"
            },
            {
                label: t("ID Value"),
                field: "einvoice_id_value",
                sort: "asc"
            },
            {
                label: t("Gender"),
                field: "gender",
                sort: "asc"
            },
            {
                label: t("Race"),
                field: "race",
                sort: "asc"
            },
            {
                label: t("Address"),
                field: "address",
                sort: "asc"
            }, {
                label: t("City"),
                field: "city",
                sort: "asc"
            },
            {
                label: t("Postcode"),
                field: "postcode",
                sort: "asc"
            },
            {
                label: t("State"),
                field: "state",
                sort: "asc"
            },
            {
                label: t("Country"),
                field: "userCountry",
                sort: "asc"
            },
            {
                label: t("Nationality"),
                field: "nationality",
                sort: "asc"
            },
            {
                label: (
                    <OverlayTrigger
                        placement="top"
                        overlay={
                            <Tooltip>
                                {t("Total number of vouchers collected")}
                            </Tooltip>
                        }
                    >
                        <span>{t("Vouchers Acquired")}</span>
                    </OverlayTrigger>
                ),
                field: "totalVouchers",
                sort: "asc"
            },
            {
                label: (
                    <OverlayTrigger
                        placement="top"
                        overlay={
                            <Tooltip>
                                {t("Total amount spent in washer machine transactions")}
                            </Tooltip>
                        }
                    >
                        <span>{t("Total Washer Payment")} {country || userCountry ? `(${currency(country || userCountry)})` : ""}</span>
                    </OverlayTrigger>
                ),
                field: "washerPayment",
                sort: "asc"
            },
            {
                label: (
                    <OverlayTrigger
                        placement="top"
                        overlay={
                            <Tooltip>
                                {t("Total amount spent in dryer machine transactions")}
                            </Tooltip>
                        }
                    >
                        <span>{t("Total Dryer Payment")} {country || userCountry ? `(${currency(country || userCountry)})` : ""}</span>
                    </OverlayTrigger>
                ),
                field: "dryerPayment",
                sort: "asc"
            },
            {
                label: (
                    <OverlayTrigger
                        placement="top"
                        overlay={
                            <Tooltip>
                                {t("Total amount spent in all transactions")}
                            </Tooltip>
                        }
                    >
                        <span>{t("Total Payment")} {country || userCountry ? `(${currency(country || userCountry)})` : ""}</span>
                    </OverlayTrigger>
                ),
                field: "totalPayment",
                sort: "asc"
            }
        ],
        rows: []
    };

    let csv = []

    if (data.length > 0) {
        for (let i = 0; i < data.length; i++) {
            const dataObject = {
                report: (
                    <button type="button" className="btn btn-link" onClick={e => memberDetailsReport(data[i].memberId, data[i].id, data[i].country)}>
                        {t("report")}
                    </button>
                ),
                action: (
                    <>
                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={() => openGiveawayModal(data[i].id, data[i].country, data[i].name, data[i].email_verified)}
                        >
                            {t("Reward")}
                        </button>
                        <button
                            type="button"
                            className="btn btn-danger mt-2"
                            onClick={() => openDeactivateModal(data[i].id, data[i].blocked)}
                        >
                            {data[i].blocked ? t("Activate") : t("Deactivate")}
                        </button>
                    </>
                ),
                token: /\./g.test(data[i].token.toString()) ? parseFloat(data[i].token).toFixed(2) : parseFloat(data[i].token),
                ...data[i],
            };
            tableData.rows.push(dataObject);

            let csvObject = {
                number: `=""${data[i].number}""`,
                birthday: new Date(data[i].birthday).toLocaleDateString('en-GB'),
                ...data[i]
            }
            csv.push(csvObject);
        }
    }

    const csvData = {
        headers: [
            { label: "Salutation", key: "salutation" },
            { label: "Name", key: "name" },
            { label: "Phone Number", key: "number" },
            { label: "Birthday", key: "birthday" },
            { label: "Age", key: "age" },
            { label: "Email Address", key: "email" },
            { label: "Member ID", key: "memberId" },
            { label: "ID Type", key: "einvoice_id_type" },
            { label: "ID Value", key: "einvoice_id_value" },
            { label: "Gender", key: "gender" },
            { label: "Race", key: "race" },
            { label: "Address", key: "address" },
            { label: "City", key: "city" },
            { label: "Postcode", key: "postcode" },
            { label: "State", key: "state" },
            { label: "Country", key: "userCountry" },
            { label: "Nationality", key: "nationality" },
            { label: "Vouchers Acquired", key: "totalVouchers" },
            { label: `Total Washer Payment ${country || userCountry ? `(${currency(country || userCountry)})` : ""}`, key: "washerPayment" },
            { label: `Total Dryer Payment ${country || userCountry ? `(${currency(country || userCountry)})` : ""}`, key: "dryerPayment" },
            { label: `Total Payment ${country || userCountry ? `(${currency(country || userCountry)})` : ""}`, key: "totalPayment" },
        ],
        data: csv
    };

    if (role === "client") {
        tableData.columns.splice(2, 0, {
            label: t("Distributor"),
            field: "distributorName",
            sort: "asc"
        })
        csvData.headers.unshift({ label: "Distributor", key: "distributorName" })
    }

    if (pointSetting) {
        tableData.columns.push({
            label: (
                <OverlayTrigger
                    placement="top"
                    overlay={
                        <Tooltip>
                            {t("Current point")}
                        </Tooltip>
                    }
                >
                    <span>{t("Point")}</span>
                </OverlayTrigger>
            ),
            field: "point",
            sort: "asc"
        })

        csvData.headers.push(
            { label: "point", key: "point" },
        )
    }

    if (tokenSetting) {
        tableData.columns.push({
            label: (
                <OverlayTrigger
                    placement="top"
                    overlay={
                        <Tooltip>
                            {t("Current e-Token")}
                        </Tooltip>
                    }
                >
                    <span>{t("e-Tokens")}</span>
                </OverlayTrigger>
            ),
            field: "token",
            sort: "asc"
        },
            {
                label: (
                    <OverlayTrigger
                        placement="top"
                        overlay={
                            <Tooltip>
                                {t("Total amount spent for buying e-Token")}
                            </Tooltip>
                        }
                    >
                        <span>{t("Bought e-Token using")} {country || userCountry ? `(${currency(country || userCountry)})` : ""}</span>
                    </OverlayTrigger>
                ),
                field: "tokenPayment",
                sort: "asc"
            },
            {
                label: (
                    <OverlayTrigger
                        placement="top"
                        overlay={
                            <Tooltip>
                                {t("Total number of e-Token purchased")}
                            </Tooltip>
                        }
                    >
                        <span>{t("Total e-Token Purchased (Tokens)")}</span>
                    </OverlayTrigger>
                ),
                field: "tokenPurchased",
                sort: "asc"
            },
            {
                label: (
                    <OverlayTrigger
                        placement="top"
                        overlay={
                            <Tooltip>
                                {t("Total number of e-Token used in washer machine transactions")}
                            </Tooltip>
                        }
                    >
                        <span>{t("Washer Payment (Tokens)")}</span>
                    </OverlayTrigger>
                ),
                field: "washerToken",
                sort: "asc"
            },
            {
                label: (
                    <OverlayTrigger
                        placement="top"
                        overlay={
                            <Tooltip>
                                {t("Total number of e-Token used in dryer machine transactions")}
                            </Tooltip>
                        }
                    >
                        <span>{t("Dryer Payment (Tokens)")}</span>
                    </OverlayTrigger>
                ),
                field: "dryerToken",
                sort: "asc"
            },
            {
                label: (
                    <OverlayTrigger
                        placement="top"
                        overlay={
                            <Tooltip>
                                {t("Total number of e-Token used in all the transactions")}
                            </Tooltip>
                        }
                    >
                        <span>{t("Total Payment (Tokens)")}</span>
                    </OverlayTrigger>
                ),
                field: "tokenUsed",
                sort: "asc"
            })

        csvData.headers.push(
            { label: "e-Tokens", key: "token" },
            { label: `Bought e-Token using ${country || userCountry ? `(${currency(country || userCountry)})` : ""}`, key: "tokenPayment" },
            { label: "Total e-Token Purchased (Tokens)", key: "tokenPurchased" },
            { label: "Washer Payment (Tokens)", key: "washerToken" },
            { label: "Dryer Payment (Tokens)", key: "dryerToken" },
            { label: "Total Payment (Tokens)", key: "tokenUsed" }
        )
    }

    if (stampSetting) {
        tableData.columns.push(
            {
                label: (
                    <OverlayTrigger
                        placement="top"
                        overlay={
                            <Tooltip>
                                {t("Number of washer stamp collected currently")}
                            </Tooltip>
                        }
                    >
                        <span>{t("Washer Stamp")}</span>
                    </OverlayTrigger>
                ),
                field: "washerStamp",
                sort: "asc"
            },
            {
                label: (
                    <OverlayTrigger
                        placement="top"
                        overlay={
                            <Tooltip>
                                {t("Number of dryer stamp collected currently")}
                            </Tooltip>
                        }
                    >
                        <span>{t("Dryer Stamp")}</span>
                    </OverlayTrigger>
                ),
                field: "dryerStamp",
                sort: "asc"
            },
            {
                label: (
                    <OverlayTrigger
                        placement="top"
                        overlay={
                            <Tooltip>
                                {t("Total number of stamps collected")}
                            </Tooltip>
                        }
                    >
                        <span>{t("Total Stamps")}</span>
                    </OverlayTrigger>
                ),
                field: "totalStamps",
                sort: "asc"
            }
        )

        csvData.headers.push(
            { label: "Washer Stamp", key: "washerStamp" },
            { label: "Dryer Stamp", key: "dryerStamp" },
            { label: "Total Stamps", key: "totalStamps" },
        )
    }

    return (
        <div className="card">
            <div className="card-header">
                <h5 className="card-title">{t("User Details")}</h5>
            </div>

            <div className="card-body">
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label htmlFor="phone">{t("User Phone Number / Member ID / Email")}:</label>
                        <input type="text" id="phone" name="phone" value={phone} onChange={(e) => setPhone(e.target.value)} required placeholder={t("Example: 0123456789,A123456")} />
                    </div>
                    <input type="submit" value={t("SEARCH")} className="btn btn-primary form-control mb-1" />
                </form>

                <div className="text-center mt-5">
                    {
                        loading ? <Loading /> : (
                            <div>
                                <MDBDataTable data={tableData} noBottomColumns striped hover responsive bordered />
                                <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                                    <CSVLink className="btn btn-primary" data={csvData.data} headers={csvData.headers} filename={`user_details_${dateFormat(new Date())}_${timeFormat(new Date())}.csv`} target="_blank">
                                        {t("Download Report")}
                                    </CSVLink>
                                </div>
                            </div>
                        )
                    }
                </div>
            </div>

            {/* Giveaway Modal */}
            <Modal
                title={t("Reward Giveaway")}
                open={giveawayModal}
                onCancel={() => setGiveawayModal(false)}
                footer={null}
                centered
            >
                <div>
                    <p>{t("Which type of reward you want to give to customer?")}</p>
                    <div className='d-flex justify-content-around'>
                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={() => { setGiveawayModal(false); setVoucherModal(true) }}
                        >
                            {t("Voucher")}
                        </button>
                        {stampSetting && (
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={() => { setGiveawayModal(false); setStampModal(true) }}
                            >
                                {t("Stamp")}
                            </button>
                        )}
                        {tokenSetting && (
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={() => { setGiveawayModal(false); setTokenModal(true) }}
                            >
                                {t("e-Token")}
                            </button>
                        )}
                        {pointSetting && (
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={() => { setGiveawayModal(false); setPointModal(true) }}
                            >
                                {t("Point")}
                            </button>
                        )}
                    </div>
                </div>
            </Modal>

            {/* Voucher Modal */}
            <Modal
                title={t("VOUCHER")}
                open={voucherModal}
                onCancel={() => setVoucherModal(false)}
                footer={null}
                centered
            >
                <form onSubmit={giveVoucher}>
                    <div className="text-left mt-4">
                        <div className="form-group">
                            <label htmlFor="title">{t("Title")}</label>
                            <input
                                type="text"
                                id="title"
                                name="title"
                                value={title}
                                onChange={(e) => setTitle(e.target.value)}
                                className="form-control"
                                required
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="description">{t("Description")}</label>
                            <input
                                type="text"
                                id="description"
                                name="description"
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                                className="form-control"
                                required
                            />
                        </div>

                        <p className="mt-5 p-0 mb-0">{t("For machine uses (required)")}</p>
                        <div className="d-flex justify-content-around mt-3 mb-2">
                            <div className="form-group">
                                <label>
                                    <input
                                        type="checkbox"
                                        id="washerUse"
                                        name="washerUse"
                                        checked={washerUse}
                                        onChange={() => setWasherUse(!washerUse)}
                                    />
                                    <span>{t("Washer Use")}</span>
                                </label>
                            </div>

                            <div className="form-group">
                                <label>
                                    <input
                                        type="checkbox"
                                        id="dryerUse"
                                        name="dryerUse"
                                        checked={dryerUse}
                                        onChange={() => setDryerUse(!dryerUse)}
                                    />
                                    <span>{t("Dryer Use")}</span>
                                </label>
                            </div>

                            <div className="form-group">
                                <label>
                                    <input
                                        type="checkbox"
                                        id="packageUse"
                                        name="packageUse"
                                        checked={packageUse}
                                        onChange={() => setPackageUse(!packageUse)}
                                    />
                                    <span>{t("Package Use")}</span>
                                </label>
                            </div>
                        </div>

                        <div className="d-flex justify-content-around mb-2">
                            <div className="form-group">
                                <label>
                                    <input
                                        type="checkbox"
                                        id="vendingUse"
                                        name="vendingUse"
                                        checked={vendingUse}
                                        onChange={() => setVendingUse(!vendingUse)}
                                    />
                                    <span>{t("Vending Use")}</span>
                                </label>
                            </div>

                            <div className="form-group">
                                <label>
                                    <input
                                        type="checkbox"
                                        id="detergentUse"
                                        name="detergentUse"
                                        checked={detergentUse}
                                        onChange={() => setDetergentUse(!detergentUse)}
                                    />
                                    <span>{t("Detergent Use")}</span>
                                </label>
                            </div>

                            <div className="form-group">
                                <label>
                                    <input
                                        type="checkbox"
                                        id="carwashUse"
                                        name="carwashUse"
                                        checked={carwashUse}
                                        onChange={() => setCarwashUse(!carwashUse)}
                                    />
                                    <span>{t("Car Wash Use")}</span>
                                </label>
                            </div>
                        </div>

                        <div className="form-group">
                            <label htmlFor="duration">
                                {t("Voucher Lifespan")} ({t("days")})
                            </label>
                            <input
                                type="text"
                                id="duration"
                                name="duration"
                                value={duration}
                                onChange={(e) => setDuration(e.target.value)}
                                className="form-control"
                                placeholder={t("leave blank if no expiry date")}
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="type">{t("Discount Type")}</label>
                            <select
                                id="type"
                                name="type"
                                className="browser-default form-select"
                                required
                                value={type}
                                onChange={(e) => setType(e.target.value)}
                            >
                                <option value="Flat">
                                    {t("Flat")} ({currency(country || userCountry)})
                                </option>
                                <option value="Rate">{t("Rate")} (%)</option>
                            </select>
                        </div>

                        <div className="form-group">
                            <label htmlFor="amount">{t("Voucher Amount")}</label>
                            <input
                                type="number"
                                id="amount"
                                name="amount"
                                className="form-control"
                                value={amount}
                                onChange={(e) => setAmount(e.target.value)}
                                min="0"
                                step="0.01"
                                required
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="remark">{t("Remarks")}</label>
                            <select
                                id="remark"
                                name="remark"
                                className="browser-default form-select"
                                value={remark}
                                onChange={(e) => setRemark(e.target.value)}
                                required
                            >
                                <option value="Reward">{t("Reward")}</option>
                                <option value="Refund">{t("Refund")}</option>
                            </select>
                        </div>

                        <div className="form-group">
                            <Form.Group controlId="adminMessage" className="mt-3">
                                <label htmlFor="Message">
                                    {t("Message for User")}{" "}
                                    {!emailVerified ? (
                                        <small>
                                            ({t("SMS will send to user, please enter the message less than 130 characters")})
                                        </small>
                                    ) : null}
                                </label>
                                <Form.Control
                                    as="textarea"
                                    rows={3}
                                    id="adminMessage"
                                    value={adminMessage}
                                    onChange={(e) => setAdminMessage(e.target.value)}
                                    placeholder={t("Enter the message to be sent to the user")}
                                    required
                                />
                            </Form.Group>
                        </div>

                        {emailVerified && (
                            <>
                                <div className="form-group">
                                    <Form.Group controlId="adminEmail" className="mt-3">
                                        <label htmlFor="Email">{t("Email Address to show on Email Template")}</label>
                                        <Form.Control
                                            type="email"
                                            id="adminEmail"
                                            value={adminEmail}
                                            onChange={(e) => setAdminEmail(e.target.value)}
                                            placeholder={t("Input Company Email Address")}
                                            required
                                        />
                                    </Form.Group>
                                </div>

                                <div className="form-group">
                                    <Form.Group controlId="adminCompanyName" className="mt-3">
                                        <label htmlFor="CompanyName">{t("Company Name to show on Email Template")}</label>
                                        <Form.Control
                                            type="text"
                                            id="adminCompanyName"
                                            value={adminCompanyName}
                                            onChange={(e) => setAdminCompanyName(e.target.value)}
                                            placeholder={t("Input Company Name")}
                                        />
                                    </Form.Group>
                                </div>

                                <div className="form-group">
                                    <Form.Group controlId="adminCompanyPhoneNo" className="mt-3">
                                        <label htmlFor="CompanyPhoneNo">{t("Company Phone No. to show on Email Template")}</label>
                                        <Form.Control
                                            type="text"
                                            id="adminCompanyPhoneNo"
                                            value={adminCompanyPhoneNo}
                                            onChange={(e) => setAdminCompanyPhoneNo(e.target.value)}
                                            placeholder={t("Input Company Phone No.")}
                                            required
                                        />
                                    </Form.Group>
                                </div>
                                <button type="button" className="btn btn-secondary" onClick={() => setShowEmailPreview(!showEmailPreview)}>
                                    {t("Preview Email")}
                                </button>
                            </>
                        )}
                    </div>

                    {loading ? (
                        <Loading />
                    ) : (
                        <div className="d-flex justify-content-center">
                            <div>
                                <button type="submit" className="btn btn-primary">
                                    {t("OK")}
                                </button>
                            </div>
                            <div className="ms-3">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={() => setVoucherModal(false)}
                                >
                                    {t("Cancel")}
                                </button>
                            </div>
                        </div>
                    )}
                </form>
            </Modal>

            {/* Stamp Modal */}
            <Modal
                title={t("STAMP")}
                open={stampModal}
                onCancel={() => setStampModal(false)}
                footer={null}
                centered
            >
                <form onSubmit={giveStamp}>
                    <div className="text-left mt-4">
                        <div className="form-group">
                            <label htmlFor="washerStamp">{t("Washer Stamp")}</label>
                            <input
                                type="number"
                                id="washerStamp"
                                name="washerStamp"
                                value={washerStamp}
                                onChange={(e) => setWasherStamp(e.target.value)}
                                className="form-control"
                                step="1"
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="dryerStamp">{t("Dryer Stamp")}</label>
                            <input
                                type="number"
                                id="dryerStamp"
                                name="dryerStamp"
                                value={dryerStamp}
                                onChange={(e) => setDryerStamp(e.target.value)}
                                className="form-control"
                                step="1"
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="remark">{t("Remarks")}</label>
                            <select
                                id="remark"
                                name="remark"
                                className="browser-default form-select"
                                value={remark}
                                onChange={(e) => setRemark(e.target.value)}
                                required
                            >
                                <option value="Reward">{t("Reward")}</option>
                                <option value="Refund">{t("Refund")}</option>
                            </select>
                        </div>

                        {
                            parseInt(washerStamp) > 0 || parseInt(dryerStamp) > 0 ? (
                                <>
                                    <div className="form-group">
                                        <Form.Group controlId="adminMessage" className="mt-3">
                                            <label htmlFor="Message">
                                                {t("Message for User")}{" "}
                                                {!emailVerified ? (
                                                    <small>
                                                        ({t("SMS will send to user, please enter the message less than 130 characters")})
                                                    </small>
                                                ) : null}
                                            </label>
                                            <Form.Control
                                                as="textarea"
                                                id="adminMessage"
                                                rows={3}
                                                value={adminMessage}
                                                onChange={(e) => setAdminMessage(e.target.value)}
                                                placeholder={t("Enter the message to be sent to the user")}
                                                required
                                            />
                                        </Form.Group>
                                    </div>

                                    {emailVerified && (
                                        <>
                                            <div className="form-group">
                                                <Form.Group controlId="adminEmail" className="mt-3">
                                                    <label htmlFor="Email">{t("Email Address to show on Email Template")}</label>
                                                    <Form.Control
                                                        type="email"
                                                        id="adminEmail"
                                                        value={adminEmail}
                                                        onChange={(e) => setAdminEmail(e.target.value)}
                                                        placeholder={t("Input Company Email Address")}
                                                        required
                                                    />
                                                </Form.Group>
                                            </div>

                                            <div className="form-group">
                                                <Form.Group controlId="adminCompanyName" className="mt-3">
                                                    <label htmlFor="CompanyName">{t("Company Name to show on Email Template")}</label>
                                                    <Form.Control
                                                        type="text"
                                                        id="adminCompanyName"
                                                        value={adminCompanyName}
                                                        onChange={(e) => setAdminCompanyName(e.target.value)}
                                                        placeholder={t("Input Company Name")}
                                                    />
                                                </Form.Group>
                                            </div>

                                            <div className="form-group">
                                                <Form.Group controlId="adminCompanyPhoneNo" className="mt-3">
                                                    <label htmlFor="CompanyPhoneNo">{t("Company Phone No. to show on Email Template")}</label>
                                                    <Form.Control
                                                        type="text"
                                                        id="adminCompanyPhoneNo"
                                                        value={adminCompanyPhoneNo}
                                                        onChange={(e) => setAdminCompanyPhoneNo(e.target.value)}
                                                        placeholder={t("Input Company Phone No.")}
                                                        required
                                                    />
                                                </Form.Group>
                                            </div>

                                            <button type="button" className="btn btn-secondary" onClick={() => setShowEmailPreview(!showEmailPreview)}>
                                                {t("Preview Email")}
                                            </button>
                                        </>
                                    )}
                                </>
                            ) : null
                        }
                    </div>

                    {loading ? (
                        <Loading />
                    ) : (
                        <div className="d-flex justify-content-center">
                            <div>
                                <button type="submit" className="btn btn-primary">
                                    {t("OK")}
                                </button>
                            </div>
                            <div className="ms-3">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={() => setStampModal(false)}
                                >
                                    {t("Cancel")}
                                </button>
                            </div>
                        </div>
                    )}
                </form>
            </Modal>

            {/* Point Modal */}
            <Modal
                title={t("POINT")}
                open={pointModal}
                onCancel={() => setPointModal(false)}
                footer={null}
                centered
            >
                <form onSubmit={givePoint}>
                    <div className="text-left mt-4">
                        <div className="form-group">
                            <label htmlFor="pointAmount">{t("Number of Point")}</label>
                            <input
                                type="number"
                                id="pointAmount"
                                name="pointAmount"
                                value={pointAmount}
                                onChange={(e) => setPointAmount(e.target.value)}
                                className="form-control"
                                step="1"
                                required
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="remark">{t("Remarks")}</label>
                            <select
                                id="remark"
                                name="remark"
                                className="browser-default form-select"
                                value={remark}
                                onChange={(e) => setRemark(e.target.value)}
                                required
                            >
                                <option value="Reward">{t("Reward")}</option>
                                <option value="Refund">{t("Refund")}</option>
                            </select>
                        </div>

                        {
                            parseInt(pointAmount) > 0 ? (
                                <>
                                    <div className="form-group">
                                        <Form.Group controlId="adminMessage" className="mt-3">
                                            <label htmlFor="Message">
                                                {t("Message for User")}{" "}
                                                {!emailVerified ? (
                                                    <small>
                                                        ({t("SMS will send to user, please enter the message less than 130 characters")})
                                                    </small>
                                                ) : null}
                                            </label>
                                            <Form.Control
                                                as="textarea"
                                                id="adminMessage"
                                                rows={3}
                                                value={adminMessage}
                                                onChange={(e) => setAdminMessage(e.target.value)}
                                                placeholder={t("Enter the message to be sent to the user")}
                                                required
                                            />
                                        </Form.Group>
                                    </div>

                                    {emailVerified && (
                                        <>
                                            <div className="form-group">
                                                <Form.Group controlId="adminEmail" className="mt-3">
                                                    <label htmlFor="Email">{t("Email Address to show on Email Template")}</label>
                                                    <Form.Control
                                                        type="email"
                                                        id="adminEmail"
                                                        value={adminEmail}
                                                        onChange={(e) => setAdminEmail(e.target.value)}
                                                        placeholder={t("Input Company Email Address")}
                                                        required
                                                    />
                                                </Form.Group>
                                            </div>

                                            <div className="form-group">
                                                <Form.Group controlId="adminCompanyName" className="mt-3">
                                                    <label htmlFor="CompanyName">{t("Company Name to show on Email Template")}</label>
                                                    <Form.Control
                                                        type="text"
                                                        id="adminCompanyName"
                                                        value={adminCompanyName}
                                                        onChange={(e) => setAdminCompanyName(e.target.value)}
                                                        placeholder={t("Input Company Name")}
                                                    />
                                                </Form.Group>
                                            </div>

                                            <div className="form-group">
                                                <Form.Group controlId="adminCompanyPhoneNo" className="mt-3">
                                                    <label htmlFor="CompanyPhoneNo">{t("Company Phone No. to show on Email Template")}</label>
                                                    <Form.Control
                                                        type="text"
                                                        id="adminCompanyPhoneNo"
                                                        value={adminCompanyPhoneNo}
                                                        onChange={(e) => setAdminCompanyPhoneNo(e.target.value)}
                                                        placeholder={t("Input Company Phone No.")}
                                                        required
                                                    />
                                                </Form.Group>
                                            </div>

                                            <button type="button" className="btn btn-secondary" onClick={() => setShowEmailPreview(!showEmailPreview)}>
                                                {t("Preview Email")}
                                            </button>
                                        </>
                                    )}
                                </>
                            ) : null
                        }
                    </div>

                    {loading ? (
                        <Loading />
                    ) : (
                        <div className="d-flex justify-content-center">
                            <div>
                                <button type="submit" className="btn btn-primary">
                                    {t("OK")}
                                </button>
                            </div>
                            <div className="ms-3">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={() => setPointModal(false)}
                                >
                                    {t("Cancel")}
                                </button>
                            </div>
                        </div>
                    )}
                </form>
            </Modal>

            {/* Token Modal */}
            <Modal
                title={t("E-TOKEN")}
                open={tokenModal}
                onCancel={() => setTokenModal(false)}
                footer={null}
                centered
            >
                <form onSubmit={giveToken}>
                    <div className="text-left mt-4">
                        <div className="form-group">
                            <label htmlFor="tokenAmount">{t("Number of e-Token")}</label>
                            <input
                                type="number"
                                id="tokenAmount"
                                name="tokenAmount"
                                value={tokenAmount}
                                onChange={(e) => setTokenAmount(e.target.value)}
                                className="form-control"
                                step="0.01"
                                required
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="remark">{t("Remarks")}</label>
                            <select
                                id="remark"
                                name="remark"
                                className="browser-default form-select"
                                value={remark}
                                onChange={(e) => setRemark(e.target.value)}
                                required
                            >
                                <option value="Reward">{t("Reward")}</option>
                                <option value="Refund">{t("Refund")}</option>
                            </select>
                        </div>


                        {
                            parseFloat(tokenAmount) > 0 ? (
                                <>
                                    <div className="form-group">
                                        <Form.Group controlId="adminMessage" className="mt-3">
                                            <label htmlFor="Message">
                                                {t("Message for User")}{" "}
                                                {!emailVerified ? (
                                                    <small>
                                                        ({t("SMS will send to user, please enter the message less than 130 characters")})
                                                    </small>
                                                ) : null}
                                            </label>
                                            <Form.Control
                                                as="textarea"
                                                rows={3}
                                                id="adminMessage"
                                                value={adminMessage}
                                                onChange={(e) => setAdminMessage(e.target.value)}
                                                placeholder={t("Enter the message to be sent to the user")}
                                                required
                                            />
                                        </Form.Group>
                                    </div>

                                    {emailVerified && (
                                        <>
                                            <div className="form-group">
                                                <Form.Group controlId="adminEmail" className="mt-3">
                                                    <label htmlFor="Email">{t("Email Address to show on Email Template")}</label>
                                                    <Form.Control
                                                        type="email"
                                                        id="adminEmail"
                                                        value={adminEmail}
                                                        onChange={(e) => setAdminEmail(e.target.value)}
                                                        placeholder={t("Input Company Email Address")}
                                                        required
                                                    />
                                                </Form.Group>
                                            </div>

                                            <div className="form-group">
                                                <Form.Group controlId="adminCompanyName" className="mt-3">
                                                    <label htmlFor="CompanyName">{t("Company Name to show on Email Template")}</label>
                                                    <Form.Control
                                                        type="text"
                                                        id="adminCompanyName"
                                                        value={adminCompanyName}
                                                        onChange={(e) => setAdminCompanyName(e.target.value)}
                                                        placeholder={t("Input Company Name")}
                                                    />
                                                </Form.Group>
                                            </div>

                                            <div className="form-group">
                                                <Form.Group controlId="adminCompanyPhoneNo" className="mt-3">
                                                    <label htmlFor="CompanyPhoneNo">{t("Company Phone No. to show on Email Template")}</label>
                                                    <Form.Control
                                                        type="text"
                                                        id="adminCompanyPhoneNo"
                                                        value={adminCompanyPhoneNo}
                                                        onChange={(e) => setAdminCompanyPhoneNo(e.target.value)}
                                                        placeholder={t("Input Company Phone No.")}
                                                        required
                                                    />
                                                </Form.Group>
                                            </div>

                                            <button type="button" className="btn btn-secondary" onClick={() => setShowEmailPreview(!showEmailPreview)}>
                                                {t("Preview Email")}
                                            </button>
                                        </>
                                    )}
                                </>
                            ) : null
                        }
                    </div>

                    {loading ? (
                        <Loading />
                    ) : (
                        <div className="d-flex justify-content-center">
                            <div>
                                <button type="submit" className="btn btn-primary">
                                    {t("OK")}
                                </button>
                            </div>
                            <div className="ms-3">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={() => setTokenModal(false)}
                                >
                                    {t("Cancel")}
                                </button>
                            </div>
                        </div>
                    )}
                </form>
            </Modal>

            {/* Email Preview Modal */}
            <Modal
                title={t("Email Preview")}
                open={showEmailPreview}
                onCancel={() => setShowEmailPreview(!showEmailPreview)}
                footer={null}
                centered
            >
                <div dangerouslySetInnerHTML={{ __html: generateEmailPreview() }} />
                <div className="d-flex justify-content-end">
                    <button type="button" className="btn btn-secondary" onClick={() => setShowEmailPreview(!showEmailPreview)}>
                        {t("Close")}
                    </button>
                </div>
            </Modal>

            <Modal
                title={blocked ? t("Activate User") : t("Deactivate User")}
                open={deactivateModal}
                onCancel={() => setDeactivateModal(false)}
                footer={null}
                centered
            >
                <div>
                    <p>{blocked ? t("Are you sure you want to activate the user account?") : t("Are you sure you want to deactivate the user account?")}</p>
                    {
                        loading ? (
                            <Loading />
                        ) : (
                            <div className='d-flex justify-content-around'>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={() => deactivateUser()}
                                >
                                    {t("OK")}
                                </button>

                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={() => setDeactivateModal(false)}
                                >
                                    {t("Cancel")}
                                </button>
                            </div>
                        )
                    }
                </div>
            </Modal>
        </div>
    )
}

export default UserDetailsCard;